export default {
    "AF": {
        "name": "Afeganistão"
    },
    "ZA": {
        "name": "África do Sul"
    },
    "AL": {
        "name": "Albânia"
    },
    "DE": {
        "name": "Alemanha"
    },
    "AD": {
        "name": "Andorra"
    },
    "AO": {
        "name": "Angola"
    },
    "AG": {
        "name": "Antígua e Barbuda"
    },
    "SA": {
        "name": "Arábia Saudita"
    },
    "DZ": {
        "name": "Argélia"
    },
    "AR": {
        "name": "Argentina"
    },
    "AM": {
        "name": "Armênia"
    },
    "AU": {
        "name": "Austrália"
    },
    "AT": {
        "name": "Áustria"
    },
    "AZ": {
        "name": "Azerbaijão"
    },
    "BS": {
        "name": "Bahamas"
    },
    "BD": {
        "name": "Bangladesh"
    },
    "BB": {
        "name": "Barbados"
    },
    "BH": {
        "name": "Barém"
    },
    "BE": {
        "name": "Bélgica"
    },
    "BZ": {
        "name": "Belize"
    },
    "BJ": {
        "name": "Benim"
    },
    "BY": {
        "name": "Bielorrússia"
    },
    "BO": {
        "name": "Bolívia"
    },
    "BA": {
        "name": "Bósnia e Herzegovina"
    },
    "BW": {
        "name": "Botswana"
    },
    "BR": {
        "name": "Brasil"
    },
    "BN": {
        "name": "Brunei"
    },
    "BG": {
        "name": "Bulgária"
    },
    "BF": {
        "name": "Burquina Fasso"
    },
    "BI": {
        "name": "Burundi"
    },
    "BT": {
        "name": "Butão"
    },
    "CV": {
        "name": "Cabo Verde"
    },
    "KH": {
        "name": "Camboja"
    },
    "CM": {
        "name": "Camarões"
    },
    "CA": {
        "name": "Canadá"
    },
    "QA": {
        "name": "Catar"
    },
    "KZ": {
        "name": "Cazaquistão"
    },
    "CF": {
        "name": "República Centro-Africana"
    },
    "TD": {
        "name": "Chade"
    },
    "CZ": {
        "name": "Chéquia"
    },
    "CL": {
        "name": "Chile"
    },
    "CN": {
        "name": "China"
    },
    "CY": {
        "name": "Chipre"
    },
    "CO": {
        "name": "Colômbia"
    },
    "KM": {
        "name": "Comores"
    },
    "CG": {
        "name": "República do Congo"
    },
    "CD": {
        "name": "República Democrática do Congo"
    },
    "KR": {
        "name": "Coreia do Sul"
    },
    "KP": {
        "name": "Coreia do Norte"
    },
    "CI": {
        "name": "Costa do Marfim"
    },
    "CR": {
        "name": "Costa Rica"
    },
    "HR": {
        "name": "Croácia"
    },
    "CU": {
        "name": "Cuba"
    },
    "DK": {
        "name": "Dinamarca"
    },
    "DJ": {
        "name": "Djibouti"
    },
    "DM": {
        "name": "Dominica"
    },
    "DO": {
        "name": "República Dominicana"
    },
    "EG": {
        "name": "Egito"
    },
    "SV": {
        "name": "El Salvador"
    },
    "AE": {
        "name": "Emirados Árabes Unidos"
    },
    "EC": {
        "name": "Equador"
    },
    "ER": {
        "name": "Eritreia"
    },
    "SK": {
        "name": "Eslováquia"
    },
    "SI": {
        "name": "Eslovênia"
    },
    "ES": {
        "name": "Espanha"
    },
    "US": {
        "name": "Estados Unidos"
    },
    "EE": {
        "name": "Estónia"
    },
    "SZ": {
        "name": "Essuatíni"
    },
    "ET": {
        "name": "Etiópia"
    },
    "FJ": {
        "name": "Fiji"
    },
    "PH": {
        "name": "Filipinas"
    },
    "FI": {
        "name": "Finlândia"
    },
    "FR": {
        "name": "França"
    },
    "GA": {
        "name": "Gabão"
    },
    "GM": {
        "name": "Gâmbia"
    },
    "GH": {
        "name": "Gana"
    },
    "GE": {
        "name": "Geórgia"
    },
    "GR": {
        "name": "Grécia"
    },
    "GD": {
        "name": "Granada"
    },
    "GT": {
        "name": "Guatemala"
    },
    "GY": {
        "name": "Guiana"
    },
    "GW": {
        "name": "Guiné-Bissau"
    },
    "GN": {
        "name": "Guiné"
    },
    "GQ": {
        "name": "Guiné Equatorial"
    },
    "HT": {
        "name": "Haiti"
    },
    "HN": {
        "name": "Honduras"
    },
    "HU": {
        "name": "Hungria"
    },
    "YE": {
        "name": "Iêmen"
    },
    "IN": {
        "name": "Índia"
    },
    "ID": {
        "name": "Indonésia"
    },
    "IQ": {
        "name": "Iraque"
    },
    "IR": {
        "name": "Irão"
    },
    "IE": {
        "name": "Irlanda"
    },
    "IS": {
        "name": "Islândia"
    },
    "IL": {
        "name": "Israel"
    },
    "IT": {
        "name": "Itália"
    },
    "JM": {
        "name": "Jamaica"
    },
    "JP": {
        "name": "Japão"
    },
    "JO": {
        "name": "Jordânia"
    },
    "KI": {
        "name": "Kiribati"
    },
    "KW": {
        "name": "Kuwait"
    },
    "LA": {
        "name": "Laos"
    },
    "LS": {
        "name": "Lesoto"
    },
    "LV": {
        "name": "Letônia"
    },
    "LB": {
        "name": "Líbano"
    },
    "LR": {
        "name": "Libéria"
    },
    "LY": {
        "name": "Líbia"
    },
    "LI": {
        "name": "Liechtenstein"
    },
    "LT": {
        "name": "Lituânia"
    },
    "LU": {
        "name": "Luxemburgo"
    },
    "MK": {
        "name": "Macedônia do Norte"
    },
    "MG": {
        "name": "Madagáscar"
    },
    "MY": {
        "name": "Malásia"
    },
    "MW": {
        "name": "Malawi"
    },
    "MV": {
        "name": "Maldivas"
    },
    "ML": {
        "name": "Mali"
    },
    "MT": {
        "name": "Malta"
    },
    "MA": {
        "name": "Marrocos"
    },
    "MH": {
        "name": "Ilhas Marshall"
    },
    "MU": {
        "name": "Maurícia"
    },
    "MR": {
        "name": "Mauritânia"
    },
    "MX": {
        "name": "México"
    },
    "MM": {
        "name": "Mianmar"
    },
    "FM": {
        "name": "Estados Federados da Micronésia"
    },
    "MZ": {
        "name": "Moçambique"
    },
    "MD": {
        "name": "Moldávia"
    },
    "MC": {
        "name": "Mónaco"
    },
    "MN": {
        "name": "Mongólia"
    },
    "ME": {
        "name": "Montenegro"
    },
    "NA": {
        "name": "Namíbia"
    },
    "NR": {
        "name": "Nauru"
    },
    "NP": {
        "name": "Nepal"
    },
    "NI": {
        "name": "Nicarágua"
    },
    "NE": {
        "name": "Níger"
    },
    "NG": {
        "name": "Nigéria"
    },
    "NO": {
        "name": "Noruega"
    },
    "NZ": {
        "name": "Nova Zelândia"
    },
    "OM": {
        "name": "Omã"
    },
    "NL": {
        "name": "Países Baixos"
    },
    "PW": {
        "name": "Palau"
    },
    "PA": {
        "name": "Panamá"
    },
    "PG": {
        "name": "Papua-Nova Guiné"
    },
    "PK": {
        "name": "Paquistão"
    },
    "PY": {
        "name": "Paraguai"
    },
    "PE": {
        "name": "Peru"
    },
    "PL": {
        "name": "Polónia"
    },
    "PT": {
        "name": "Portugal"
    },
    "KE": {
        "name": "Quênia"
    },
    "KG": {
        "name": "Quirguistão"
    },
    "GB": {
        "name": "Reino Unido"
    },
    "RO": {
        "name": "Roménia"
    },
    "RW": {
        "name": "Ruanda"
    },
    "RU": {
        "name": "Rússia"
    },
    "WS": {
        "name": "Samoa"
    },
    "SB": {
        "name": "Ilhas Salomão"
    },
    "SM": {
        "name": "San Marino"
    },
    "LC": {
        "name": "Santa Lúcia"
    },
    "KN": {
        "name": "São Cristóvão e Neves"
    },
    "ST": {
        "name": "São Tomé e Príncipe"
    },
    "VC": {
        "name": "São Vicente e Granadinas"
    },
    "SN": {
        "name": "Senegal"
    },
    "SL": {
        "name": "Serra Leoa"
    },
    "RS": {
        "name": "Sérvia"
    },
    "SC": {
        "name": "Seicheles"
    },
    "SG": {
        "name": "Singapura"
    },
    "SY": {
        "name": "Síria"
    },
    "SO": {
        "name": "Somália"
    },
    "LK": {
        "name": "Sri Lanka"
    },
    "SD": {
        "name": "Sudão"
    },
    "SS": {
        "name": "Sudão do Sul"
    },
    "SE": {
        "name": "Suécia"
    },
    "CH": {
        "name": "Suíça"
    },
    "SR": {
        "name": "Suriname"
    },
    "TH": {
        "name": "Tailândia"
    },
    "TJ": {
        "name": "Tajiquistão"
    },
    "TZ": {
        "name": "Tanzânia"
    },
    "TL": {
        "name": "Timor-Leste"
    },
    "TG": {
        "name": "Togo"
    },
    "TO": {
        "name": "Tonga"
    },
    "TT": {
        "name": "Trindade e Tobago"
    },
    "TN": {
        "name": "Tunísia"
    },
    "TM": {
        "name": "Turquemenistão"
    },
    "TR": {
        "name": "Turquia"
    },
    "TV": {
        "name": "Tuvalu"
    },
    "UA": {
        "name": "Ucrânia"
    },
    "UG": {
        "name": "Uganda"
    },
    "UY": {
        "name": "Uruguai"
    },
    "UZ": {
        "name": "Uzbequistão"
    },
    "VU": {
        "name": "Vanuatu"
    },
    "VE": {
        "name": "Venezuela"
    },
    "VN": {
        "name": "Vietnã"
    },
    "ZM": {
        "name": "Zâmbia"
    },
    "ZW": {
        "name": "Zimbabwe"
    }
}